import React, { useCallback, useEffect, useState } from 'react';

import { useServiceOrder } from '~/hooks/ServiceOrder';
import { IMFileType } from '~/models/FileTypes';
import api from '~/services/api';

import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import Swal from 'sweetalert2';
import Loading from '~/components/Loading';
import BoxDocumentGroups from '../BoxDocumentGroups';
import { Container } from './styles';

const CustomersDocuments: React.FC = () => {
  const { serviceOrder } = useServiceOrder();
  const [seeMore, setSeeMore] = useState(
    serviceOrder.status_id === 9 || serviceOrder.status_id === 11
  );
  const [fileTypes, setFileTypes] = useState<IMFileType[]>([]);
  const [loading, setLoading] = useState(false);

  const loadDocumentLists = useCallback(async () => {
    try {
      setLoading(true);
      await api
        .get<IMFileType[]>(`builders/file-types/${serviceOrder.id}`, {
          params: {
            grupo: 2,
          },
        })
        .then((response) => {
          // if (
          //   serviceOrder.finalidade_id === 3
          //   || serviceOrder.finalidade_id === 4
          //   || serviceOrder.finalidade_id === 6
          // ) {
          //   const LIST_FILES_FILTERED = response.data.filter((file) => file.id === 19)
          //   setFileTypes(LIST_FILES_FILTERED);
          // }else{
          // }
          setFileTypes(response.data);
        });
    } catch (err) {
      await Swal.fire(
        'Opss...',
        'Ocorreu um erro ao carregar os tipos de documentos!',
        'error'
      );
    } finally {
      setLoading(false);
    }
  }, [serviceOrder.id, serviceOrder.finalidade_id]);

  useEffect(() => {
    loadDocumentLists();
  }, [loadDocumentLists, serviceOrder]);

  const handleUpdateFileTypes = useCallback(() => {
    loadDocumentLists();
  }, [loadDocumentLists]);

  return (
    <div>
      <div className="mt-4">
        <b>Documento para abertura de processo</b>
      </div>
      <Container className="px-2 mt-2 pb-2 d-flex flex-column">
        <div className="d-flex w-full">
          <div className="col-12 d-flex justify-content-end me-4 mt-3">
            {!seeMore ? (
              <button
                type="button"
                onClick={() => setSeeMore(true)}
                className="d-flex flex-row text-primary fw-bold align-items-center gap-2"
              >
                Ver mais <MdKeyboardArrowDown />
              </button>
            ) : (
              <button
                type="button"
                onClick={() => setSeeMore(false)}
                className="d-flex flex-row text-primary fw-bold align-items-center gap-2"
              >
                Ver menos <MdKeyboardArrowUp />
              </button>
            )}
          </div>
        </div>
        {seeMore && (
          <div>
            {fileTypes.map((fileType) => (
              <div key={fileType.id} className="mt-4">
                <BoxDocumentGroups
                  fileType={fileType}
                  onChangeFiles={handleUpdateFileTypes}
                />
              </div>
            ))}
          </div>
        )}
      </Container>
      <Loading active={loading} />
    </div>
  );
};

export default CustomersDocuments;
